import { IconSailboat } from '@tabler/icons-react';
import { IconMapper } from '../../../common/helpers/IconMapper';

interface Props {
  boatFacilities: Array<{
    __typename?: 'BoatFacility';
    name: string;
    iconName?: string | null;
  }>;
  setShowBoatFacilities: (show: boolean) => void;
}

const BoatFeatureComponent = (props: Props) => {
  return (
    <div className="mt-2 flex flex-col items-start gap-6 self-stretch">
      <div className="flex gap-2 items-center">
        <IconSailboat size={24} />
        <span className="text-2xl font-semibold text-neutral-800">
          Boat features
        </span>
      </div>
      <div className="flex flex-col items-start gap-4 flex-1 text-neutral-500 md:hidden">
        {props.boatFacilities.slice(0, 5).map(facility => (
          <div className="flex items-center gap-2">
            {IconMapper(facility.iconName ?? '', 20)}
            <span>{facility.name}</span>
          </div>
        ))}
      </div>
      <div className="hidden grid-cols-2 items-start gap-4 flex-1 text-neutral-500 max-w-[40.3125rem] w-full md:grid">
        {props.boatFacilities.slice(0, 10).map(facility => (
          <div className="flex items-center gap-2">
            {IconMapper(facility.iconName ?? '', 20)}
            <span>{facility.name}</span>
          </div>
        ))}
      </div>
      <div>
        <button
          className="flex px-6 py-3 justify-center items-center gap-2 rounded-lg border border-neutral-800 md:hidden"
          onClick={() => {
            props.setShowBoatFacilities(true);
          }}
        >
          <span className="text-base font-semibold">
            See all {props.boatFacilities.length} facilities
          </span>
        </button>
        <button
          className="hidden md:flex px-6 py-3 justify-center items-center gap-2 rounded-lg border border-neutral-800"
          onClick={() => {
            props.setShowBoatFacilities(true);
          }}
        >
          <span className="text-base font-semibold">
            See all {props.boatFacilities.length} facilities
          </span>
        </button>
      </div>
    </div>
  );
};

export default BoatFeatureComponent;
